module.exports = __webpack_public_path__ + "static/media/Poppins-SemiBold.6f1520d1.ttf";